// extracted by mini-css-extract-plugin
export default {"GeneralModalMaker":"GeneralModalMaker_GeneralModalMaker__DZvDE","buttonLabel":"GeneralModalMaker_buttonLabel__iar5u"};